import { timelineSteps } from '@/mocks/cg51';
import SectionHeading from './SectionHeading';

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          overline="焦点时间线"
          title="#0409 · 一场12天的完整追踪"
          note="从第一条零散线索到复盘归档，事件经历了四次阶段跃迁。这里只呈现可引用的节点，存疑内容一律旁注说明。"
        />

        <div className="mx-auto max-w-3xl">
          <ol className="relative">
            <span
              aria-hidden
              className="absolute top-2 bottom-2 left-[7px] w-px bg-background-300"
            />
            {timelineSteps.map((step, idx) => (
              <li key={step.title} className="relative flex gap-5 pb-8 pl-0 md:gap-8 md:pb-10">
                <span
                  className={`relative mt-1.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full ${
                    idx === timelineSteps.length - 1 ? 'bg-accent-500' : 'bg-background-50 ring-1 ring-background-300'
                  }`}
                />
                <div className="flex flex-1 flex-col gap-2">
                  <div className="flex items-center gap-3">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-foreground-950 px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap text-background-50">
                      {step.date}
                    </span>
                    <span className="text-xs font-medium text-secondary-700">{step.mark}</span>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{step.title}</h3>
                  <p className="max-w-xl text-sm leading-relaxed text-foreground-600">{step.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}